import { useCallback } from 'preact/hooks'
import { Action } from '@gsc/types'
import { useAppDispatch } from '../store/store'
import { processActions } from '../store/actions'
import { useWidgetContext } from './useWidgetContext'

export interface WidgetActions {
  (actions: Action[], origin?: string): Promise<boolean>
}

export const useActions = (): WidgetActions => {
  const dispatch = useAppDispatch()
  const { widgetId } = useWidgetContext()
  return useCallback<WidgetActions>(
    (actions, origin) => dispatch(processActions(widgetId, actions, origin)),
    [dispatch, widgetId],
  )
}
